<template>
    <b-modal ref="modal" centered :visible="true" @hidden="onModalHidden">
        <template slot="modal-header">
            {{ Translations.buttons.createDayTemplate }}
        </template>
        <template>
            <b-form class="form" @submit.prevent="createDayTemplate">
                <input type="hidden" id="stationUid" name="stationUid" v-model="dtData.stationUid" />
                <div class="linked-properties">
                    <b-form-group id="group-name" :label="Translations.labels.name" label-for="name" :label-cols="4">
                        <b-form-input autofocus id="name" name="name" v-model="dtData.name" type="text" required autocomplete="off" :placeholder="Translations.placeholders.name" />
                    </b-form-group>
                    <b-form-group id="color-container" :label="Translations.labels.color" label-for="colorCode" :label-cols="4">
                        <b-form-input id="name" name="colorCode" v-model="dtData.colorCode" type="color" :placeholder="Translations.placeholders.color" />
                    </b-form-group>
                </div>
            </b-form>
        </template>
        <template slot="modal-footer">
            <Button :empty="true" class="close-popup" @click.prevent="cancelModal">{{ Translations.buttons.cancel }} </Button>
            <Button :empty="false" class="validate" :disabled="!isFormValid" @click.prevent="createDayTemplate">{{ Translations.buttons.doCreateDayTemplate }} </Button>
        </template>
    </b-modal>
</template>
<script>
    import Button from'@/components/common/Button'
    import Bootstrap from 'bootstrap-vue';
    import store from '@/store';
    import Translations from '@/store/translations';
    import EventBus from '@/eventbus';
    import Portlet from '@/components/common/Portlet.vue'
    import { HTTP } from "@/utils/http";
    import { mapState } from 'vuex';
    import router from '@/router';

    export default {
        name: "DayTemplateCreationCard",
        store, router,
        components: { Portlet, Bootstrap, Button },
        computed: {
            ...mapState(['currentStation']),
            Translations: function () { return Translations; },
            isFormValid() {
                const { name } = this.dtData;
                return name && name.trim().length;
            }
        },
        data() {
            return {
                modalState: {
                    show: true,
                    visible: true,
                },
                dtData: {
                    stationUid: this.$store.state.currentStationUid,
                    name: "",
                    colorCode: "#ff6a00",
                }
            }
        }
        , methods: {
            cancelModal() { this.$refs['modal'].hide() },
            createDayTemplate() {
                if (this.isFormValid) {
                    HTTP.post("api/daytemplates/create", this.dtData)
                        .then(this.onDayTemplateCreated, this.onDayTemplateCreationError)
                        .then(function () {
                        });
                }
            },
            onDayTemplateCreated(response) {
                console.log(response);
                this.creationResponse = response;
                if (this.creationResponse.status === 200) {
                    var newItem = this.creationResponse.data;
                    if (newItem != null && newItem.dataItem != null) {
                        router.push({ name: 'DayTemplateDetails', params: { dayTemplateUid: newItem.dataItem.uid } });
                        store.dispatch('loadStationDayTemplates', this.currentStation.uid);
                        this.cancelModal();
                    }
                }
                else {
                    //let vue build the error messages
                }
            },
            onDayTemplateCreationError(response) {
                console.log(response);
                this.creationResponse = response;
                console.error(response);
            },
            onModalHidden() { EventBus.$emit('onDayTemplateCreationEnded'); }
        }
    }
</script>
<style>
</style>
